import { Stack, Button } from "@mui/material";

import BottomActionBar from "@pages/Layout/BottomActionBar";
import { useNavigate } from "react-router-dom";

interface Props {
  orderId: number;
  showPlanReview: object | undefined;
  showCancelButton: boolean;
}

const PlanningTemplateBottomBar = ({
  orderId,
  showPlanReview,
  showCancelButton,
}: Props) => {
  const navigate = useNavigate();

  return (
    <BottomActionBar>
      <Stack
        direction="row-reverse"
        justifyContent="space-between"
        sx={{
          width: 1,
          padding: 1,
          borderTop: "1px solid",
          borderTopColor: "divider",
        }}
      >
        <Button
          data-testid={"planning-template-submit"}
          variant="contained"
          onClick={() => {
            if (showPlanReview) {
              navigate(`/commandcenter/${orderId}/plan-review`);
            } else {
              navigate(`/commandcenter/${orderId}/handover`);
            }
          }}
        >
          Next: {showPlanReview ? "Plan Review" : "Handover"}
        </Button>

        {showCancelButton && (
          <Button
            data-testid={"planning-template-cancel"}
            variant="outlined"
            onClick={() => navigate(`/commandcenter/${orderId}/automated`)}
          >
            Cancel
          </Button>
        )}
      </Stack>
    </BottomActionBar>
  );
};

export default PlanningTemplateBottomBar;
